<app-header [label]="page_name"></app-header>

<!-- Dropdown Filters -->
<div class="bg-white px-6 py-4 flex items-center gap-3 border-b border-gray-100">
  <app-select-input label="University" [is_disabled]="gs.access_scope.locked.university" class="w-56" [options]="university_options" [(ngModel)]="params.university_id" (ngModelChange)="on_university_change()"></app-select-input>
  <app-select-input label="Academic Year" class="flex-1" [options]="filtered_academic_years" [(ngModel)]="params.academic_year_id" (ngModelChange)="on_academic_year_change()"></app-select-input>
  <app-select-input label="Exam Name" class="flex-1" [options]="filtered_exams" [(ngModel)]="params.exam_id" (ngModelChange)="on_exam_change()"></app-select-input>
  <app-select-input label="Subject Name" [is_disabled]="gs.access_scope.locked.subject" class="flex-1" [options]="filtered_subjects" [(ngModel)]="params.subject_id" (ngModelChange)="apply_filters()"></app-select-input>
  <app-search-input placeholder="Search here..." class="flex-1" (valueChange)="get_list({ search: $event, page: 1 })"></app-search-input>
  <button (click)="download()" class="w-[50px] h-10 flex items-center justify-center rounded-full border border-[#3F41D1] text-[#3F41D1] flex-shrink-0">
    <i class="bx bx-download text-xl"></i>
  </button>
</div>

<!-- Table -->
<app-ag-grid-list [list]="items" [colDefs]="columns" [show_checkboxes]="false" [itemName]="page_name" [rowHeight]="60" (fetch_new_list)="get_list($event)">
</app-ag-grid-list>

<app-payment-receipt #receipt_modal></app-payment-receipt>